import { defineStore, acceptHMRUpdate } from 'pinia';

export const useNotificationsStore = defineStore('NotificationsStore', () => {
  const notifications = ref<Map<string, string[]>>();
  notifications.value = new Map();
  notifications.value.set(NotificationTypes.Trophies, []);

  const notifiedStates = ref<Map<string, boolean>>();
  notifiedStates.value = new Map();
  notifiedStates.value.set(NotificationTypes.Trophies, false);

  const storage = useNomadStorage('notifications', {});

  for (const key of notifications.value.keys()) {
    if (storage.value[key]) {
      notifications.value.set(key, storage.value[key].split(','));
    }
  }

  const push = (type: keyof typeof NotificationTypes, ids: string[]) => {
    const currentIds = notifications.value.get(type);
    notifications.value.set(type, [...currentIds, ...ids]);
    notifiedStates.value.set(type, false);
  };
  const clear = (type: keyof typeof NotificationTypes) => {
    notifications.value.set(type, []);
  };
  const emitHasBeenNotified = (type: keyof typeof NotificationTypes) => {
    notifiedStates.value.set(type, true);
  };
  const clearIfHasBeenNotfied = (type: keyof typeof NotificationTypes) => {
    if (notifiedStates.value.get(type)) {
      notifications.value.set(type, []);
    }
  };

  watch(
    () => notifications.value.get(NotificationTypes.Trophies),
    (ids) => {
      storage.value[NotificationTypes.Trophies] = ids.join(',');
    }
  );

  return {
    notifications,
    notifiedStates,
    push,
    clear,
    emitHasBeenNotified,
    clearIfHasBeenNotfied,
  };
});
if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useNotificationsStore, import.meta.hot)
  );
}
